exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".table[data-v-4dc69c83]{color:inherit}.table td[data-v-4dc69c83]{padding:10px!important;padding-top:5px;border-bottom:1px solid #ddd;border-top:0 solid #ddd;margin-right:10px}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?minimize!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-4dc69c83","scoped":true,"hasInlineConfig":false}!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/components/team/manage-team.vue
// module id = 1620
// module chunks = 0